import React from 'react';

import MyButton from '../button/Button';

interface FormCancelWarningProperties {
  title: string;
  description: string;
  cancelButtonLabel?: string;
  cancelButtonOnClick?: () => void;
  submitButtonLabel?: string;
  submitButtonOnClick?: () => void;
}

/**
 * Form cancel warning component
 * @param {any} properties Component properties
 * @returns {any} form cancel warning
 */
function FormCancelWarning(properties: FormCancelWarningProperties) {
  const {
    title,
    description,
    cancelButtonLabel,
    cancelButtonOnClick,
    submitButtonLabel,
    submitButtonOnClick,
  } = properties;

  return (
    <div className="form-cancel-warning-wrap">
      <div className="form-cancel-waring-content">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <div className="form-cancel-button">
        <MyButton
          label={cancelButtonLabel || 'Cancel'}
          buttonType="back"
          onClickFunc={cancelButtonOnClick}
          disableHoverEffect
        />
        <MyButton
          label={submitButtonLabel || 'Submit'}
          buttonType="error"
          onClickFunc={submitButtonOnClick}
        />
      </div>
    </div>
  );
}

FormCancelWarning.defaultProps = {
  cancelButtonLabel: '',
  cancelButtonOnClick: null,
  submitButtonLabel: '',
  submitButtonOnClick: null,
};

export default FormCancelWarning;
